import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const redeemAccessCampaignTokenFn = httpsCallable(functions, 'redeemAccessCampaignToken');

const ACCESS_CODE_ERROR_KEY_BY_CODE = {
  CAMPAIGN_TOKEN_INVALID: 'auth:errors.accessCodeInvalid',
  ACCESS_CODE_INVALID: 'auth:errors.accessCodeInvalid',
  INVALID_ACCESS_CODE: 'auth:errors.accessCodeInvalid',
  CAMPAIGN_TOKEN_EXPIRED: 'auth:errors.accessCodeExpired',
  ACCESS_CODE_EXPIRED: 'auth:errors.accessCodeExpired',
  EXPIRED_ACCESS_CODE: 'auth:errors.accessCodeExpired',
  CAMPAIGN_TOKEN_REVOKED: 'auth:errors.accessCodeRevoked',
  ACCESS_CODE_REVOKED: 'auth:errors.accessCodeRevoked',
  REVOKED_ACCESS_CODE: 'auth:errors.accessCodeRevoked',
  CAMPAIGN_TOKEN_ALREADY_USED: 'auth:errors.accessCodeAlreadyUsed',
  ACCESS_CODE_ALREADY_USED: 'auth:errors.accessCodeAlreadyUsed',
  ALREADY_USED_ACCESS_CODE: 'auth:errors.accessCodeAlreadyUsed',
  CAMPAIGN_TOKEN_ALREADY_REDEEMED: 'auth:errors.accessCodeAlreadyUsed',
  ACCESS_CODE_ALREADY_REDEEMED: 'auth:errors.accessCodeAlreadyUsed',
  CAMPAIGN_TOKEN_ALREADY_PAID_USER: 'auth:errors.accessCodePaidUser',
  ACCESS_CODE_ALREADY_PAID_USER: 'auth:errors.accessCodePaidUser',
  PAID_USER_NOT_ELIGIBLE: 'auth:errors.accessCodePaidUser',
};

export function normalizeAccessCampaignCode(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, '')
    .toUpperCase();
}

export function getAccessCampaignErrorTranslationKey(error) {
  const code = String(error?.details?.code || error?.code || '').trim();
  return ACCESS_CODE_ERROR_KEY_BY_CODE[code] || 'auth:errors.accessCodeGeneric';
}

export async function redeemAccessCampaignToken(accessCode) {
  const normalizedAccessCode = normalizeAccessCampaignCode(accessCode);
  if (!normalizedAccessCode) {
    throw {
      code: 'CAMPAIGN_TOKEN_INVALID',
      message: 'Access code is required',
    };
  }

  const result = await redeemAccessCampaignTokenFn({
    accessCode: normalizedAccessCode,
  });

  return result?.data || null;
}

export default {
  normalizeAccessCampaignCode,
  getAccessCampaignErrorTranslationKey,
  redeemAccessCampaignToken,
};
